// Copyright (c) 2016 Deere & Company

import actions from '../../actions-list';

export const toggleAllClaimTypes = allowedClaimTypes =>

    dispatch => {

        dispatch({
            data: false,
            type: actions.UPDATE_USER_PREFERENCES_IS_SAVED
        });

        dispatch({
            allowedClaimTypes,
            type: actions.UPDATE_USER_PREFERENCES_ALL_CLAIM_TYPES
        });

    };

export const updateClaimType = (claimType, isSelected) =>

    dispatch => {

        dispatch({
            data: false,
            type: actions.UPDATE_USER_PREFERENCES_IS_SAVED
        });

        dispatch({
            claimType,
            isSelected,
            type: actions.UPDATE_USER_PREFERENCES_CLAIM_TYPE
        });

    };

export const updateDbsAutoSubmit = (key, list) =>

    dispatch => {

        dispatch({
            data: false,
            type: actions.UPDATE_USER_PREFERENCES_IS_SAVED
        });

        dispatch({
            autoSubmit: list.find(item => item.key === key),
            type: actions.UPDATE_USER_PREFERENCES_DBS_AUTO_SUBMIT
        });

    };



// WEBPACK FOOTER //
// ./src/user/shared/action-creators/dbs-settings.js